<template>
  <Head title="Avid - Sign Up" />
  
  <div class="container-fluid d-flex flex-column h-100 onboarding-container">
    <onboarding-new :agency="agency" :error="errors"></onboarding-new>
  </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({
  agency: {
    type: Object,
    default: null
  },
  errors: Object
});
</script>

